import { render, staticRenderFns } from "./LoginDevice.vue?vue&type=template&id=48db63c4&"
import script from "./LoginDevice.vue?vue&type=script&lang=ts&"
export * from "./LoginDevice.vue?vue&type=script&lang=ts&"
import style0 from "./LoginDevice.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports